import React from 'react';
import {
  RenderElementProps, useFocused, useSelected,
} from 'slate-react';
import Mention from 'src/components/Mention';
import { MentionElement as MentionElementType } from 'src/types/CustomSlateTypes';

export type MentionElementProps = {
  element: MentionElementType;
} & RenderElementProps;

const MentionElement = ({ element, children, attributes }: MentionElementProps) => {
  const selected = useSelected();
  const focused = useFocused();
  const focusedStyles = selected && focused ? 'outline-1 outline-kat-eastern outline' : '';

  return (
    <span
      {...attributes}
      contentEditable={false}
      data-testid="mention-element"
    >
      <Mention
        username={element.username}
        className={focusedStyles}
      />
      {children}
    </span>
  );
};

export default MentionElement;
